import { connect } from 'react-redux';
import RecommendationsLoader from './recommendationsLoader';

function mapStateToProps({ recommendations: { data, isLoading, failed } = {} }) {
  let loadedState = failed || !data?.recommendations?.length ? 'failed' : 'success';
  loadedState = isLoading ? 'loading' : loadedState;
  return { loadedState };
}

export default connect(mapStateToProps)(RecommendationsLoader);
